import { FormControl, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { MapContext } from '../models';
import { domoUrl } from './embed';

interface Props {
    data: any
}
export function DemographicReportView(props: Props) {

    const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state.epiProps.clergyCompReportSettingsState.epiContent);
    const seletedDio = useSelector<TcsmStates, string>(state => state?.clergyCompReportState.selectedDio);
    const [value, setValue] = useState('gender');
    const handleChange = (evt) => setValue(evt?.target?.value);
    const mapContext = useSelector<TcsmStates, MapContext>(state => state?.clergyCompReportState?.mapContext);
    return (
        <>
            <div className='clergycomp-infographic-header'>
                <div>
                    <h2>{settings?.demographicLabel}</h2>
                    <p>{settings?.demographicSubTitle}</p>
                </div>
                <FormControl >
                    <Select
                        value={value}
                        onChange={handleChange}

                    >
                        {
                            Object.keys(props?.data)?.map(a => <MenuItem key={a} value={a}>{props?.data[a]?.display}</MenuItem>)
                        }
                    </Select>

                </FormControl>
            </div>
            {
                props?.data[value]?.items.map(a => {
                    if (a.hideWhenSelectedDio) {
                        return seletedDio ? null : <iframe
                            title={`report-${a.id}`}
                            src={`${domoUrl}/api/card?reportName=${a.id}`}
                            name={`${a.id}`}
                            data-group={a.filter}
                            id={`report-${a.id}`}
                            width='900' height='600'
                            marginHeight={0}
                            marginWidth={0}
                            frameBorder={0}
                        />;
                    }
                    if (a.showOnSelectedDio) {
                        return !seletedDio ? null : <iframe
                            title={`report-${a.id}`}
                            src={`${domoUrl}/api/card?reportName=${a.id}`}
                            name={`${a.id}`}
                            data-group={a.filter}
                            id={`report-${a.id}`}
                            width='900' height='600'
                            marginHeight={0}
                            marginWidth={0}
                            frameBorder={0}
                        />;
                    }
                    return <iframe
                        title={`report-${a.id}`}
                        src={`${domoUrl}/api/card?reportName=${a.id}`}
                        name={`${a.id}`}
                        data-group={a.filter}
                        id={`report-${a.id}`}
                        width='900' height='600'
                        marginHeight={0}
                        marginWidth={0}
                        frameBorder={0}
                    />;
                })
            }
            {
                mapContext === MapContext.DOMESTIC &&
                <WysiwygWithReactLink content={settings?.demographicHelperText} />
            }
        </>
    );
}